import { ref, onMounted } from 'vue';

export function useInstallPrompt() {
  const deferredPrompt = ref<any>(null);
  const isInstallable = ref(false);
  const isInstalled = ref(false);

  onMounted(() => {
    // Check if app is already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      isInstalled.value = true;
      return;
    }

    // Listen for the beforeinstallprompt event
    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Store the event so it can be triggered later
      deferredPrompt.value = e;
      // Update UI to show install button
      isInstallable.value = true;
    });

    // Listen for app installed event
    window.addEventListener('appinstalled', () => {
      // Log app installed
      console.log('PWA was installed');
      isInstalled.value = true;
      isInstallable.value = false;
      deferredPrompt.value = null;
    });
  });

  const showInstallPrompt = async () => {
    if (!deferredPrompt.value) {
      console.log('Cannot show install prompt - not available');
      return;
    }

    // Show the install prompt
    deferredPrompt.value.prompt();
    
    // Wait for the user to respond to the prompt
    const choiceResult = await deferredPrompt.value.userChoice;
    
    // User accepted the prompt
    if (choiceResult.outcome === 'accepted') {
      console.log('User accepted the install prompt');
    } else {
      console.log('User dismissed the install prompt');
    }
    
    // We no longer need the prompt
    deferredPrompt.value = null;
    isInstallable.value = false;
  };

  return {
    isInstallable,
    isInstalled,
    showInstallPrompt
  };
}
